import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap'; 
import { ActivatedRoute, Router } from '@angular/router';
import { MultipleSelectItemComponent } from '../multiple-select-item/multiple-select-item.component';
import { SelectCustomerComponent } from '../select-customer/select-customer.component';
import { SelectStoreComponent } from '../select-store/select-store.component';
import { SelectExecutiveComponent } from '../select-executive/select-executive.component';
import { DataService } from "../../services/data.service";
import { CommonService } from '../../services/common.service';
import { APIService } from '../../api.service';
import { indexOf, isNumber } from 'lodash';
import { debug } from 'console';
import { BatchSelectionComponent } from '../batch-selection/batch-selection.component';
import { FindCompComponent } from '../../find-comp/find-comp.component';

// import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { MultiUnitCalculatorComponent } from '../multi-unit-calculator/multi-unit-calculator.component';
import { callbackify } from 'util';

@Component({
  selector: 'app-store-transfer',
  templateUrl: './store-transfer.component.html',
  styleUrls: ['./store-transfer.component.scss']
})
export class StoreTransferComponent implements OnInit {

  isshowRefresh: boolean = false;
  modalReference: any;
  id: number = 0;
  title: string = '';
  errorMessageWord: string = '';
  isDispatch: boolean = false;
  isStoreTransfer: boolean = false;
  isIssueDirect: boolean = false;
  isReturnDirect: boolean = false;
  isGNR: boolean = false; // Inverd Receipt
  isJobwork: boolean = false;
  transferQty: number = 0;
  stores: any = [];
  frmStore = {
      name: '',
      id: 0
  };
  toStore = {
      name: '',
      id: 0
  };
  isToStoreSel: boolean = false;
  customer = {
      name: '',
      id: 0
  }
  isCustSelected: boolean = false;
  executive = {
      name: '',
      id: 0
  }
  isWeb: boolean = true;
  jarvisData: any = [];
  MTbl: any = [];
  HTbl: any = [];
  xnNotes: string = '';
  xnCode: any;
  ERP_Cfg: any = [];
  isShowPrevNo: boolean = false;
  prevXnCode: any;
  tmpDisptDet: any = [];
  disptDetSelect: number = 0;
  disptDetValue: string = '';
  dispatchDetailJSON: any = [];
  displayArr: any = [];
  selCustAddr: number = 0;
  isShowAddr: boolean = false;
  custAddress: any = [];
  Cfg_AgnCfg: any = [];
  lastXNNos: any = [];
  selectedCustomerAddress: string = '';
  erpItems: Array < any > = [];
  userList: Array < any > = [];
  invoiceID: number = 0;
  invoiceStoreID: number = 0;
  addrID: number = 0;
  isFromInvList: boolean = false;
  Items: Array < any > = [];
  ItemCategories: any = [];
  categories: Array < any > = [];
  NameExcLng: boolean = false;
  isInvQty: boolean = false;
  copyItemListFromDoc: Array < any > = [];
  color: any;
  type: string = '';
  isFromCashMemo: boolean = false;
  isInternalXfer: boolean = false;
  invRights: any = [];
  isRateView: boolean = false;
  batchCnt: any = 0;
  batchMode: any = '';
  batchList: any = [];
  isB2C: boolean = false;

  constructor(private modalService: NgbModal, private _Activatedroute: ActivatedRoute, private appService: DataService, private apiService: APIService, private router: Router, private commonService: CommonService, private SpinnerService: NgxSpinnerService) {}

  //id == 1 : Dispatch
  //id == 2 : Store Transfer
  //id == 3 : Issue Direct
  //id == 4 : Return Direct
  //id == 5 : GNR
  //id == 7 : Job Work (Out) - Dispatch
  //id == 8 : Job Work (Out) - Receive

  ngOnInit(): void {
      this.resetBatchesData()
      var jarvis = this.apiService.getCookie("Jarvis");
      if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
      };

      this.isWeb = this.apiService.apiCheckWeb();

      var tblM = this.apiService.getCookie("M");
      if (tblM) {
          this.MTbl = JSON.parse(tblM);
          this.isB2C = this.MTbl[0].IsB2C;
      }

      var tblERP_Cfg = this.apiService.getCookie("ERP_Cfg");
      if (tblERP_Cfg) {
          this.ERP_Cfg = JSON.parse(tblERP_Cfg);
          if (this.ERP_Cfg[0].ItemCategories) {
              this.categories = JSON.parse(this.ERP_Cfg[0].ItemCategories)
          }
          if (this.ERP_Cfg[0].Stores) {
            this.stores = JSON.parse(this.ERP_Cfg[0].Stores);
          }
      }
      this.apiService.getIDB('erp_inv', (erpItem: any) => {
        if (erpItem && erpItem.length > 0) {
          this.erpItems = erpItem;
        } else {
          this.getItemListData();
        }
      });
      let userList: any = this.apiService.getCookie("J");
      if (userList) {
          this.userList = JSON.parse(userList);
          let ownUserID: number = this.jarvisData[0].UserID;
          this.invRights = $.grep(this.userList, function(o: any) {
              return o.UserID == ownUserID
          })[0];
          if (this.invRights) {
              this.isRateView = this.invRights.InvRateView;
          }
      }

        //Get Items
        this.appService.items.subscribe((value: any) => {
            // Define the map with proper typing to store both properties
            const existingItemsMap: { [key: number]: { transferQty?: string, Notes?: string } } = {};
            
            if (this.items) {
                this.items.forEach((item: any) => {
                    if (item.ItemID) {
                        existingItemsMap[item.ItemID] = {
                            transferQty: item.transferQty,
                            Notes: item.Notes
                        };
                    }
                });
            }
            
            this.items = value;
            this.batchCnt = 0;
            
            this.items.forEach((element: any) => {
                if (existingItemsMap[element.ItemID]?.transferQty) {
                    element.transferQty = existingItemsMap[element.ItemID].transferQty;
                }
                
                if (existingItemsMap[element.ItemID]?.Notes) {
                    element.Notes = existingItemsMap[element.ItemID].Notes;
                } else if (!element.Notes) {
                    element.Notes = '';
                }
                
                element.Batches = element.Batches ? element.Batches : [];
                
                if (element.StoreBatches.length > 0) {
                    element.StoreItemQty = Number(element.StoreItemQty).toFixed(element.SKUPrecision);
                } else {
                    element.CurrQty = Number(element.CurrQty).toFixed(element.SKUPrecision);
                }
                if (element.BatchType == 1 || element.BatchType == 2) {
                    element.hasBatches = true;
                    this.batchCnt = this.batchCnt + 1
                } else {
                    element.hasBatches = false;
                }
            });
        });



      //Get Store
      this.appService.store.subscribe((a: any) => {
          this.frmStore.id = a.id;
          this.frmStore.name = a.name;
      });

      // Get Batches Data for perticular Item
      this.appService.batches.subscribe((value: any) => {
        if (value) {
            this.items.forEach((element: any, idx: number) => {
                const matchByIndex = value.itemIndex !== undefined && value.itemIndex !== -1;
                if (matchByIndex ? idx === value.itemIndex : value.itemID == element.ItemID) {
                    element.Batches = JSON.parse(JSON.stringify(value.batchList));
                    element.sumBatchesQty = value.sumBatchesQty;
                    element.oldBatchList = JSON.parse(JSON.stringify(value.oldBatchList));
                }
            });
        }
    });

      var tmpCfg_AgnCfg = this.apiService.getCookie("Cfg_AgnCfg");

      //Get H from IDB
      var self = this;
      this.apiService.getIDB('H', (dataList: any) => {
          if (dataList) {
              self.HTbl = dataList;
          }
          self.id = self._Activatedroute.snapshot.params['id'];

          if (tmpCfg_AgnCfg) {
              self.Cfg_AgnCfg = JSON.parse(tmpCfg_AgnCfg);
              if (self.Cfg_AgnCfg[0].LastXnNos) {
                  self.lastXNNos = JSON.parse(self.Cfg_AgnCfg[0].LastXnNos);

                  let tmpNo = self.id == 3 ? 5 : self.id == 4 ? 2 : self.id == 5 ? 1 : self.id == 1 ? 4 : self.id == 2 ? 9 : self.id == 7 ? 12 : self.id == 8 ? 13 : 0;
                  let tmpType = 'XN-' + tmpNo;

                  self.lastXNNos = self.lastXNNos.filter((a: any) => a.XnTyp == tmpType);
              }
          }
          if (self.lastXNNos.length > 0) {
              let tmpLastXnNo = self.lastXNNos[0].LastNo;
              if (tmpLastXnNo) {
                  if (isNaN(tmpLastXnNo)) {
                      self.isShowPrevNo = true;
                      self.prevXnCode = tmpLastXnNo;
                  } else {
                      self.isShowPrevNo = false;
                      self.xnCode = Number(tmpLastXnNo) + 1;
                  }
                  // if(tmpLastXnNo.match(/^[0-9]+$/) != null) {
                  //   this.isShowPrevNo = false;
                  //   this.xnCode = Number(tmpLastXnNo) + 1;
                  // } 
                  // else {
                  //   this.isShowPrevNo = true;
                  //   this.prevXnCode = tmpLastXnNo;
                  // }
              }
          } else {
              self.xnCode = 1;
          }


          self.invoiceID = self._Activatedroute.snapshot.params['invID'] ? self._Activatedroute.snapshot.params['invID'] : 0;
          self.invoiceStoreID = self._Activatedroute.snapshot.params['sid'] ? self._Activatedroute.snapshot.params['sid'] : 0;
          self.addrID = self._Activatedroute.snapshot.params['adID'] ? self._Activatedroute.snapshot.params['adID'] : 0;
          self.isFromInvList = self._Activatedroute.snapshot.params['FrmI'] ?
              (self._Activatedroute.snapshot.params['FrmI'] == 1 ? true : false) : false;
          self.type = self._Activatedroute.snapshot.params['type'] ? self._Activatedroute.snapshot.params['type'] : '';

          if (self.invoiceStoreID > 0) {
              let stores = self.ERP_Cfg[0].Stores;
              if (stores) {
                  stores = JSON.parse(stores);
                  let selectedStore = stores.filter((i: any) => i.StrID == self.invoiceStoreID);
                  if (selectedStore.length > 0) {
                      self.frmStore.id = self.invoiceStoreID;
                      self.frmStore.name = selectedStore[0].sNm;
                  }
              }
          } else if (self.isFromInvList && self.invoiceStoreID == 0) {
              if (self.id == 1) {
                  self.frmStore.id = 0;
                  self.frmStore.name = 'Select Store';
              } else if (self.id == 5) {
                  self.toStore.id = 0;
                  self.toStore.name = 'Select Store';
                  self.frmStore.id = 0;
                  self.frmStore.name = 'Select Store';
              }
              self.fn_getDocDetails();
          }

          if (self.frmStore.id == 0 && !self.isFromInvList) {
              if (self.id == 1) {
                  self.frmStore.id = 0;
                  self.frmStore.name = 'Select Store';
                  self.isFromInvList = true;
              }
          }

          if (self.id == 1) {
              // dispatch
              self.title = 'Dispatch';
              self.errorMessageWord = 'dispatch';
              self.isDispatch = true;
              this.type = self.type;

              if (this.type == 'DDBN') {
                let tmpSup = self.HTbl.filter((a: any) => a.S == true);
                if (tmpSup.length == 1) {
                    self.isCustSelected = true;
                    self.customer.id = tmpSup[0].RI;
                    self.customer.name = tmpSup[0].Cmp;
                }
              }
              else {
                  let tmpCust = self.HTbl.filter((a: any) => a.C == true);
                  if (tmpCust.length == 1) {
                    self.isCustSelected = true;
                    self.customer.id = tmpCust[0].RI;
                    self.customer.name = tmpCust[0].Cmp;
                  }
              }
          } else if (self.id == 2) {
              // store transfer
              self.title = 'Store Transfer';
              self.errorMessageWord = 'store transfer';
              self.isStoreTransfer = true;

              if (self.stores.length == 1) {
                  self.isToStoreSel = true;
                  self.toStore.id = self.stores[0].StrID;
                  self.toStore.name = self.stores[0].sNm;
              }

          } else if (self.id == 3) {
              // Stock Issue;
              self.title = 'Issue to User';
              self.errorMessageWord = 'issue to user';
              self.isIssueDirect = true;

              // Only one user to get 
              if (self.userList.length == 1) {
                  self.executive.id = self.userList[0].UserID;
                  self.executive.name = self.userList[0].Name;
              }
          } else if (self.id == 4) {
              // Return ;
              self.title = 'Receive from User';
              self.errorMessageWord = 'receive from user';
              self.isReturnDirect = true;

              // Only one user to get 
              if (self.userList.length == 1) {
                  self.executive.id = self.userList[0].UserID;
                  self.executive.name = self.userList[0].Name;
              }
          } else if (self.id == 5) {
              // Inward Receipt
              self.title = 'Purchase Inward (GRN)';
              self.errorMessageWord = "purchase inward (GRN)";
              self.isGNR = true;
              this.type = self.type;

              if (this.type === 'DCRN') {
                let tmpCust = self.HTbl.filter((a: any) => a.C == true);
                if (tmpCust.length == 1) {
                  self.isCustSelected = true;
                  self.customer.id = tmpCust[0].RI;
                  self.customer.name = tmpCust[0].Cmp;
                }
              }
              else {
                let tmpSup = self.HTbl.filter((a: any) => a.S == true);
                if (tmpSup.length == 1) {
                  self.isCustSelected = true;
                  self.customer.id = tmpSup[0].RI;
                  self.customer.name = tmpSup[0].Cmp;
                }
              }
            } else if (self.id == 7) {
                self.title = 'Job Work (Out) - Dispatch';
                self.errorMessageWord = 'this transaction';
                self.isJobwork = true;
  
                if (self.stores.length == 1) {
                    self.isToStoreSel = true;
                    self.toStore.id = self.stores[0].StrID;
                    self.toStore.name = self.stores[0].sNm;
                }
                
                let tmpSup = self.HTbl.filter((a: any) => a.S == true);
                if (tmpSup.length == 1) {
                    self.isCustSelected = true;
                    self.customer.id = tmpSup[0].RI;
                    self.customer.name = tmpSup[0].Cmp;
                    // this.selectedCustomerAddress = JSON.stringify({
                    //     City: tmpSup[0].City,
                    //     State: tmpSup[0].State
                    // });
                }
            } else if (self.id == 8) {
                self.title = 'Job Work (Out) - Receive';
                self.errorMessageWord = 'this transaction';
                self.isJobwork = true;
  
                if (self.stores.length == 1) {
                    self.isToStoreSel = true;
                    self.toStore.id = self.stores[0].StrID;
                    self.toStore.name = self.stores[0].sNm;
                }

                const store = this.stores.find((store: any) => store.StrID == this.frmStore.id);
                if (store) {
                    let tmpSup = self.HTbl.filter((a: any) => a.RI == store?.RID && store?.IsJobStr); 
                    this.isCustSelected = true;
                    if(tmpSup.length > 0) {
                        self.customer.id = tmpSup[0].RI;
                        self.customer.name = tmpSup[0].Cmp;
                        // this.selectedCustomerAddress = JSON.stringify({
                        //     City: tmpSup[0].City,
                        //     State: tmpSup[0].State
                        // });
                    }
                } 
            }

          if (self.invoiceID > 0 && self.isFromInvList == false) {
              self.fn_getDocDetails();
          }

      })

      this.tmpDisptDet = [{
          id: 1,
          name: 'Shipper',
          value: '',
          index: 0
      }, {
          id: 2,
          name: 'Docket No.',
          index: 0
      }, {
          id: 3,
          name: 'Mode',
          index: 0
      }, {
          id: 4,
          name: 'Vehicle No.',
          index: 0
      }];
      this.tmpDisptDet.forEach((element: any, index: number) => {
          element.index = index;
      });




      // if (this.invoiceID > 0 && this.isFromInvList == false) {
      //   this.fn_getDocDetails();
      // }
      //this.stores = [{ id: 1, name: 'Home' }, { id: 2, name: 'Godown' }, { id: 3, name: "Deep's home" }, { id: 4, name: "Jaimin's home" }, { id: 5, name: "Abhishek's home" }];
  }

  items: any = [];

  openItemSelect(content: any) {
      this.modalReference = this.modalService.open(MultipleSelectItemComponent, {
          windowClass: "itemSelectionModalClass",
          backdrop: 'static',
          keyboard: false
      });
      this.modalReference.componentInstance.typeID = this.id;
      this.modalReference.componentInstance.it = this.items.map((a: any) => a.ItemID);
      this.modalReference.componentInstance.st = this.frmStore.id;
      this.modalReference.componentInstance.stc = 0;
      this.modalReference.componentInstance.mdlRef = this.modalReference;
      this.modalReference.componentInstance.invoiceID = this.invoiceID;
      this.modalReference.componentInstance.invouceStoreID = this.invoiceStoreID;
  }


  selectStore(content: any) {
        if (this.id == 7 && !this.isCustSelected) {
            this.apiService.successAlert("Please select the supplier to select the store.");
            return;
        }

      this.modalReference = this.modalService.open(SelectStoreComponent, {
          backdrop: 'static',
          keyboard: false,
          windowClass: 'select-store'
      });
      this.modalReference.componentInstance.mdlRef = this.modalReference;
      this.modalReference.componentInstance.showSupStore = this.id == 7 ? true : false;
      this.modalReference.componentInstance.relID = this.customer.id;
      this.modalReference.result.then((result: any) => {
          if (result.length > 0) {
              this.toStore.id = result[0].StrID;
              this.toStore.name = result[0].sNm;
              this.isToStoreSel = true;
          }

      });
  }

  //openFromStore() - Open from Store Modal
  openFromStore(content: any) {
      this.modalReference = this.modalService.open(SelectStoreComponent, {
          backdrop: 'static',
          keyboard: false
      });
      this.modalReference.componentInstance.mdlRef = this.modalReference;
      this.modalReference.componentInstance.isFromInvList = this.isFromInvList
      this.modalReference.componentInstance.StoreID = this.frmStore.id;
      this.modalReference.result.then((result: any) => {
          if (result.length > 0) {
              this.frmStore.id = result[0].StrID;
              this.frmStore.name = result[0].sNm;

              if (this.invoiceID > 0) {
                  this.invoiceStoreID = this.frmStore.id;
                  this.fn_getDocDetails();
              }
          }
      });
  }

  openBatchSelectionMdl(content: any, itemIndex: number) {
      if (this.id == 4 || this.id == 5 || this.id == 2) {
          this.batchMode = "In";
      } else if (this.id == 1 || this.id == 2 || this.id == 3) {
          this.batchMode = "Out";
      }
      this.modalReference = this.modalService.open(BatchSelectionComponent, {
          windowClass: "BatchSelection",
          backdrop: 'static',
          keyboard: false
      });
      this.modalReference.componentInstance.mdlRef = this.modalReference;
      this.modalReference.componentInstance.modeType = this.batchMode;
      this.modalReference.componentInstance.isXn = true;
      this.batchList = [];
      this.batchList = JSON.parse(JSON.stringify(this.items[itemIndex].Batches));
      this.modalReference.componentInstance.batchesList = this.batchList;

      this.modalReference.componentInstance.itemID = content.ItemID;
      this.modalReference.componentInstance.itemIndex = itemIndex;
      this.appService.updateByProduct(content);
  }

  backBtn() {
      window.history.back();
  }

  getTransferQty(ind: any) {

      //this.transferQty = _.sumBy(this.items, 'transferQty');
      this.transferQty = 0;
      this.color = ''
      for (let i = 0; i < this.items.length; i++) {
          let batches: Array < any > = this.items[i].StoreBatches;
          let selectedBatches: Array < any > = [];
          let storeQty: number = 0;
          if (this.id == 1 || this.id == 3) {
              selectedBatches = batches.filter((x: any) => x.SID == this.frmStore.id);
              if (selectedBatches.length > 0) {
                  storeQty = selectedBatches[0].Q;
              }
          }
          // if((this.id == 1 || this.id == 3) && (Number(this.items[i].transferQty) > Number(this.items[i].StoreBatches[0].Q))) {
          if ((this.id == 1 || this.id == 3) && (Number(this.items[i].transferQty) > Number(storeQty))) {
              this.color = 'Red';
              this.apiService.successAlert('Please enter a quantity less than stock quantity.');
              this.transferQty += Number(this.items[i].transferQty);
              return;
          }

          if (this.items[i].transferQty) {
              this.transferQty += Number(this.items[i].transferQty);
          }
      }
  }

  transfer() {
      // if(this.frmStore.id == 0){
      //   alert('Select Store First.');
      //   return;
      // }

      if ((this.customer.id == 0) && (this.id == 1) && (!this.isFromCashMemo && !this.isInternalXfer)) {
          this.apiService.successAlert('Please select a customer.');
          return;
      }

      if ((this.customer.id == 0) && (this.id == 5 || this.id == 7 || this.id == 8)) {
          this.apiService.successAlert('Please select a supplier.');
          return;
      }

      if ((this.executive.id == 0) && (this.id == 3 || this.id == 4)) {
          this.apiService.successAlert('Please select an executive.');
          return;
      }

      if ((this.toStore.id == 0) && (this.id == 2 || this.id == 7 || this.id == 8)) {
          this.apiService.successAlert('Please select a store.');
          return;
      } else if (this.id == 1 && this.frmStore.id == 0) {
          this.apiService.successAlert('Please select a store.');
          return;
      } else if (this.id == 1 && this.frmStore.id == 0) {
          this.apiService.successAlert('Please select a store.');
          return;
      }

      if (!this.xnCode) {
          this.apiService.successAlert('Please enter Ref No.');
          return;
      }

      if (this.id == 7) {
        const supStore = this.stores.find((store: any) => store.StrID == this.toStore.id);
        if (!supStore || supStore.RID != this.customer.id) {
            this.apiService.successAlert('Please select a valid supplier store.');
            return;
        }
      }

      // let a = 0;
      // this.items.forEach((element: any) => {
      //   if(element.transferQty) {
      //     a = 1;
      //     return;
      //   }
      // });

      // if(a == 0) {
      //   alert('Please enter qty.');
      //   return;
      // }

      let chkQty = this.items.filter((x: any) => !x.transferQty || x.transferQty == 0);

      if (chkQty.length > 0) {
          this.apiService.successAlert('Please enter quantity of ' + chkQty[0].ItemName + '.');
          return;
      }
      let btchQtyCheck = this.items.filter((b: any) => {
        let transferQty = Number(b.transferQty).toFixed(b.SKUPrecision);
        let sumOfBatchesQty = Number(b.sumBatchesQty).toFixed(b.SKUPrecision);
        return transferQty != sumOfBatchesQty && b.hasBatches && !this.isStoreTransfer && !this.isJobwork;
      });
      if (btchQtyCheck.length > 0) {
          this.apiService.successAlert("Kindly ensure that the total quantity of batches matches the total quantity being transferred for " + btchQtyCheck[0].ItemName + ".");
          return;
      }

      let items: any = [];
      let inItems: any = [];
      let outItems: any = [];
      let srNo: number = 1;
      const mergedItemsMap = new Map<string, any>();

        this.items.forEach((e: any) => {
            const key = `${e.ItemID}_${e.SKU}`;
            if (!mergedItemsMap.has(key)) {
                mergedItemsMap.set(key, { ...e, Batches: e.Batches ? JSON.parse(JSON.stringify(e.Batches)) : [] });
            } else {
                const existing = mergedItemsMap.get(key);
                existing.transferQty = (Number(existing.transferQty) || 0) + (Number(e.transferQty) || 0);
                // Merge batches: combine batches, summing qty for same BID/B
                if (e.Batches && e.Batches.length > 0) {
                    e.Batches.forEach((nb: any) => {
                        const existingBatch = existing.Batches.find((eb: any) => eb.BID === nb.BID && eb.B === nb.B);
                        if (existingBatch) {
                            existingBatch.Q = (Number(existingBatch.Q) || 0) + (Number(nb.Q) || 0);
                        } else {
                            existing.Batches.push({ ...nb });
                        }
                    });
                }
            }
        });
        const itemsToProcess = Array.from(mergedItemsMap.values());

        itemsToProcess.forEach((e: any) => {
                
                if(e.Batches) {
                    e.Batches = e.Batches.filter((x: any) => Number(x.Q) != 0);
                }
                let tmpSrNo = srNo++
                if (e.transferQty) {
                    if (this.id == 4 || this.id == 5 || this.id == 2 || this.id == 7 || this.id == 8) {
                  inItems.push({
                      SrNo: tmpSrNo,
                      ItemID: e.ItemID,
                      InQty: parseFloat(e.transferQty) + "",
                      OutQty: "0",
                      Unit: e.SKU,
                      Rate: (this.id == 5 ? e.DefPurchRate : e.DefStockRate),
                      Notes: e.Notes ? e.Notes : '',
                      BatchID: 0,
                      BatchNo: 0,
                      Batches: e.Batches ? JSON.stringify(e.Batches) : '[]'
                  })
              }

              if (this.id == 1 || this.id == 2 || this.id == 3 || this.id == 7 || this.id == 8) {
                  outItems.push({
                      SrNo: tmpSrNo,
                      ItemID: e.ItemID,
                      InQty: "0",
                      OutQty: parseFloat(e.transferQty) + "",
                      Unit: e.SKU,
                      Rate: e.DefStockRate,//(this.id == 1 ? e.DefSaleRate : e.DefStockRate),
                      Notes: e.Notes ? e.Notes : '',
                      BatchID: 0,
                      BatchNo: 0,
                      Batches: e.Batches ? JSON.stringify(e.Batches) : '[]'
                  })
              }
          }
      });

      let obj = [{
          XnTypeID: this.id == 3 ? 5 : this.id == 4 ? 2 : this.id == 5 ? 1 : this.id == 1 ? 4 : this.id == 2 ? 9 : this.id == 7 ? 12 : this.id == 8 ? 13 : 0,
          XnNo: this.xnCode,
          XnNotes: this.xnNotes,
          InItems: JSON.stringify(inItems),
          OutItems: JSON.stringify(outItems),
          InStoreID: this.id == 2 || this.id == 7 || this.id == 8 ? this.toStore.id : this.id == 4 || this.id == 5 ? this.frmStore.id : 1,
          OutStoreID: this.frmStore.id,
          ExecUserID: this.executive.id, //this.jarvisData[0].UserID,
          RelativeID: this.customer.id,
          OrderID: 0,
          PrdJobID: 0,
          DocDispatchID: 0,
          DocInvoiceID: 0,
          XnFields: this.id == 1 ? JSON.stringify(this.dispatchDetailJSON) : JSON.stringify([]),
          RelAddr: this.id == 1 || this.id == 7 || this.id == 8 ? this.selectedCustomerAddress : '',
          DocIDs: this.invoiceID
      }];

      let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          ForERPAgencyID: this.MTbl[0].ERPAgencyID,
          myLastSyncDT: null,
          isWeb: true,
          actionType: 'setTransaction',
          moduleID: 5,
          data: JSON.stringify(obj)
      }];

      this.apiService.swalConfirm(`${this.id == 7 || this.id == 8 ? 'Please note this transaction will not update the stock quantity in the inventory.  ' : ''}Are you sure you want to enter ${this.errorMessageWord}?`, () => {
          this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
      });

      // if (confirm("Are you sure you want to enter" + this.title + "?")) {
      //   this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
      // }

  }

  successEntry(res: any) {
        if (res.error) {
            this.apiService.successAlert(res.message);
        } 
        else {
            if (!res.updatePackage) {
                this.apiService.successAlert(res.message);
            }
          else {
          let altTxt = '';
          this.id == 1 ? altTxt = 'Item dispatched.' : this.id == 2 || this.id == 7 || this.id == 8 ? altTxt = 'Item transferred.' : this.id == 3 ? altTxt = 'Item issued.' : this.id == 4 ? altTxt = 'Item returned.' : altTxt = 'Inward receipt.';
          this.apiService.successAlert(altTxt + '!');
          
          let responseData = JSON.parse(res.updatePackage);
          let xnID = responseData.Table[0].XnID;

          var abcCfg_AgnCfg;
          abcCfg_AgnCfg = this.apiService.getCookie("Cfg_AgnCfg");

          // call fun print challan dilivery data.
          this.printTranjection(xnID);

          if (abcCfg_AgnCfg) {
              abcCfg_AgnCfg = JSON.parse(abcCfg_AgnCfg);
          }

          let latNos = JSON.parse(abcCfg_AgnCfg[0].LastXnNos);
          let tmpNo = this.id == 3 ? 5 : this.id == 4 ? 2 : this.id == 5 ? 1 : this.id == 1 ? 4 : this.id == 2 ? 9 : this.id == 7 ? 12 : this.id == 8 ? 13 : 0;
          let tmpType = 'XN-' + tmpNo;
          let index = 0;
          let tmpFilter = this.lastXNNos.filter((a: any) => a.XnTyp == tmpType);

          if (tmpFilter.length > 0) {

              latNos.forEach((element: any, index: number) => {
                  if (element.XnTyp == tmpType) {
                      element.LastNo = this.xnCode;
                  }
              });
          } else {
              let tmpObj = {
                  "XnTyp": tmpType,
                  "LastNo": this.xnCode
              }

              latNos.push(tmpObj);
          }

          abcCfg_AgnCfg[0].LastXnNos = JSON.stringify(latNos);
          this.apiService.setCookie('Cfg_AgnCfg', JSON.stringify(abcCfg_AgnCfg));

          if (this.invoiceID == 0 && (this.id == 1 || this.id == 5)) {
              this.apiService.swalConfirm("Do you wish to create invoice?", () => {
                  let typeName: string = "Supplier Invoices" //Invoices
                  if (this.id == 1) {
                      typeName = "Invoices"
                  }
                  let url: string = "";
                  if (this.apiService.fn_isLiveURL() == true) {
                      url = "../../main.html#/DocBuilder?isN=1&Type=" + typeName + "&xnID=" + xnID
                  } else {
                      url = "http://localhost:62854/main.html#/DocBuilder?isN=1&Type=" + typeName + "&xnID=" + xnID;
                  }
                  window.location.href = url;

              }, () => {
                  this.router.navigate(['Stock']);
              });
              // let isAllowforInvoice = confirm("Do you wish to create invoice?");
              // if(isAllowforInvoice == true) {
              //   let typeName: string = "Supplier Invoices" //Invoices
              //   if(this.id == 1) {
              //     typeName = "Invoices"
              //   }
              //   let url: string = "";
              //   url = "../../main.html#/DocBuilder?isN=1&Type=" + typeName + "&xnID=" + xnID
              //   // url = "http://localhost:62854/main.html#/DocBuilder?isN=1&Type=" + typeName + "&xnID=" + xnID;
              //   window.location.href = url;
              // }
              // else {
              //   this.router.navigate(['Stock']);
              // }
          } else {
              if (this.invoiceID > 0 && (this.id == 1) && (this.type != 'DDBN')) {
                  let url: string = "";
                  if (this.apiService.fn_isLiveURL() == true) {
                      url = "../../main.html#/Invoices"
                  } else {
                      url = "http://localhost:62854/main.html#/Invoices";
                  }
                  window.location.href = url;
              } else if (this.invoiceID > 0 && (this.id == 5) && (this.type != 'DCRN')) {
                  let url: string = "";
                  if (this.apiService.fn_isLiveURL() == true) {
                      url = "../../main.html#/Docs?M=6"
                  } else {
                      url = "http://localhost:62854/main.html#/Docs?M=6";
                  }
                  window.location.href = url;
              } else if (this.invoiceID > 0 && (this.id == 5) && (this.type == 'DCRN')) {
                  let url: string = "";
                  if (this.apiService.fn_isLiveURL() == true) {
                      url = "../../main.html#/Docs?M=4"
                  } else {
                      url = "http://localhost:62854/main.html#/Docs?M=4";
                  }
                  window.location.href = url;
              } else if (this.invoiceID > 0 && (this.id == 1) && (this.type == 'DDBN')) {
                  let url: string = "";
                  if (this.apiService.fn_isLiveURL() == true) {
                      url = "../../main.html#/Docs?M=5"
                  } else {
                      url = "http://localhost:62854/main.html#/Docs?M=5";
                  }
                  window.location.href = url;
                  // let toSendData = {'itemID': 0, 'batchList': [], 'sumBatchesQty': 0}	
                  // this.appService.updateBathesData(toSendData)
                  // this.batchList = []; 
                  // this.appService.updateBathesData(this.batchList)
              } else {
                  this.router.navigate(['Stock']);
                  this.resetBatchesData();
              }

          }
        }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
      if (res.error) {} else {
          this.apiService.successAlert(res.message);
          this.resetBatchesData();
          //alert(this.title + ' done!');
      }
  }

  openSelectCustomer(id: number) {

      let tmpCust = this.HTbl.filter((a: any) => a.C == true);
      let tmpSup = this.HTbl.filter((a: any) => a.S == true);

      if ((id == 1) && (tmpSup.length == 0)) {
          this.apiService.successAlert('Please configure the supplier from Network > Connections.');
          return;
      }

      if ((id == 2) && (tmpCust.length == 0)) {
          this.apiService.successAlert('Please configure the customer from Network > Connections.');
          return;
      }

      this.modalReference = this.modalService.open(SelectCustomerComponent, {
          backdrop: 'static',
          keyboard: false,
      });
      this.modalReference.componentInstance.isCust = id == 1 ? false : true;
      this.modalReference.componentInstance.isShowCS = (this.id == 1 || this.id == 5) ? true : false;
      this.modalReference.componentInstance.custID = this.customer.name;
      this.modalReference.componentInstance.mdlRef = this.modalReference;
      this.modalReference.result.then((result: any) => {

          if (result.length > 0) {
              this.customer.id = result[0].RI;
              this.customer.name = result[0].Cmp;
              this.isCustSelected = true;

              let tmpCustAddr = this.HTbl.filter((a: any) => a.RI == this.customer.id);

              // if(tmpCustAddr[0].Adrs) {
              //   this.isShowAddr = true;
              //   this.custAddress = JSON.parse(tmpCustAddr[0].Adrs);
              // }

              this.getRelDetails(tmpCustAddr[0].RI);
          }
      });
  }

  openSelectExecutive() {
      this.modalReference = this.modalService.open(SelectExecutiveComponent, {
          backdrop: 'static',
          keyboard: false
      });
      this.modalReference.componentInstance.mdlRef = this.modalReference;
      this.modalReference.result.then((result: any) => {
          if (result.length == 1) {
              this.executive.id = result[0].UserID;
              this.executive.name = result[0].Name;
          }
      });
  }

  prcisionCheck(obj: any) {
      obj.transferQty = this.commonService.PrecisionwiseValue(obj.transferQty + '', obj.SKUPrecision);
      console.log("Transfer Dispatch qty with prec...", obj.transferQty)
      // obj.CurrQty = this.commonService.PrecisionwiseValue(obj.CurrQty + '', obj.SKUPrecision);
  }

  deleteItem(index: number) {
      this.items.splice(index, 1);
      this.getTransferQty(0);
  }

  saveDispatchDetails() {
      let selected: any = [];
      if (this.disptDetSelect != 0) {
          selected = this.tmpDisptDet.filter((a: any) => a.id == this.disptDetSelect);
          console.log("selected")
      }

      if (this.disptDetSelect == 0) {
          this.apiService.successAlert('Please select dispatch detail type.');
          return;
      } else if (this.disptDetValue == '') {
          this.apiService.successAlert('Please enter the value of ' + selected[0].name + '.');
          return;
      } else {
          this.dispatchDetailJSON.push({
              'key': selected[0].name,
              'val': this.disptDetValue
          });

          this.displayArr.push({
              name: selected[0].name,
              value: this.disptDetValue,
              id: selected[0].id
          })

          this.tmpDisptDet.splice(selected[0].index, 1);
          this.tmpDisptDet.forEach((element: any, index: number) => {
              element.index = index;
          });
          this.disptDetSelect = 0;
          this.disptDetValue = '';
      }

  }

  deleteDisDet(index: number, obj: any) {
      this.tmpDisptDet.push({
          id: obj.id,
          name: obj.name,
          index: 0
      });
      this.tmpDisptDet.forEach((element: any, index: number) => {
          element.index = index;
      });

      this.displayArr.splice(index, 1);
      this.dispatchDetailJSON.splice(index, 1);
  }

  createCustAddr() {
      let tmpAddr = this.custAddress.filter((c: any) => c.AddrID == this.selCustAddr);

      this.selectedCustomerAddress = JSON.stringify(tmpAddr[0]);
      // this.selectedCustomerAddress = tmpAddr[0].Line1 + (tmpAddr[0].Line2 != '' ? ', ' + tmpAddr[0].Line2 : '') + (tmpAddr[0].City != '' ? '\r\n' + tmpAddr[0].City + ", " : '') +
      //                                tmpAddr[0].State + (tmpAddr[0].Pincode != "" ? ' - ' + tmpAddr[0].Pincode : '');
      // this.selectedCustomerAddress = this.selectedCustomerAddress + (tmpAddr[0].GSTIN ? ("\r\nGSTIN : " + tmpAddr[0].GSTIN) : '');

  }

  addNewCustomerAddr() {
      window.location.href = "../../main.html#/Network";
  }

  //fn_getDocDetails() - Invvoice Details from Invoice number
  fn_getDocDetails() {

      this.items = [];
      // alert((this.id == 5 ? 'DSPLINV' : 'DINV'));
      let type: any = this.id == 5 ? 'DSPLINV' : 'DINV'
      let data = [{
          DocID: this.invoiceID,
          DocType: type
      }]

      let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: null,
          isWeb: true,
          ForERPAgencyID: this.MTbl[0].ERPAgencyID,
          actionType: 'doc_Details',
          moduleID: 10,
          data: JSON.stringify(data)
      }];

      return this.apiService.getData(myParams, this.successInvResp.bind(this), this.failureInvoiceResp.bind(this));

  }

  //failureResp - failure handler
  failureInvoiceResp(res: any) {
      if (res.error) {} else {
          this.apiService.successAlert(res.message);
      }
  }

  //successResp - success  get handler
  successInvResp(res: any) {
      if (res.error) {} else {
          if (res) {
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData.Table[0].ErrCode == 1) {
                  this.apiService.successAlert(reponseData.Table[0].ErrMsg);
                  // this.router.navigateByUrl('/Stock');
              } else {
                  let invoiceData = reponseData.Table1;
                  this.selCustAddr = Number(this.addrID);
                
                  let tmpCust: Array < any > = this.HTbl.filter((a: any) => a.C == true && a.RI == invoiceData[0].BuyerRelIDInSeller);
                  // if(tmpCust.length == 1){
                  //   this.customer.id = tmpCust[0].RelativeID;
                  //   this.customer.name = tmpCust[0].CompanyName;
                  // }
                  if (tmpCust.length > 0) {
                      this.customer.id = tmpCust[0].RI;
                      this.customer.name = this.isB2C ? tmpCust[0].Name : tmpCust[0].Cmp;
                      this.isCustSelected = true;
                      this.getRelDetails(this.customer.id);

                      // if(tmpCust[0].Adrs) {
                      //   this.isShowAddr = true;
                      //   //this.custAddress = JSON.parse(tmpCust[0].Adrs);
                      //   this.getRelDetails(this.customer.id);     
                      // }
                  } else {
                      let tmpSup = this.HTbl.filter((a: any) => a.S == true && a.RI == invoiceData[0].SellerRelIDInBuyer);

                      if (tmpSup.length > 0) {
                          this.customer.id = tmpSup[0].RI;
                          this.customer.name = tmpSup[0].Cmp;
                          this.isCustSelected = true;
                          this.getRelDetails(this.customer.id);
                          // if(tmpSup[0].Adrs) {
                          //   this.isShowAddr = true;
                          //   //this.custAddress = JSON.parse(tmpSup[0].Adrs);
                          //   this.getRelDetails(this.customer.id);     
                          // }

                      }
                  }

                  if (invoiceData[0].BuyerRelIDInSeller == 0 && invoiceData[0].SellerRelIDInBuyer == 0) {
                    if (invoiceData[0]?.IsInternal) {
                        this.isInternalXfer = true;
                    }
                    
                    if (this.id == 1) { // Dispatch
                        if (!this.isInternalXfer) {
                            this.isFromCashMemo = true;
                        }
                        else {
                            this.isCustSelected = true;
                        }
                        if (this.customer.id == 0) {
                            this.customer.name = invoiceData[0].BuyerAgencyName ? invoiceData[0].BuyerAgencyName : '';
                        }
                    }
                  }
                  let allInvItems = invoiceData[0].Items;
                  if (allInvItems) {
                      allInvItems = JSON.parse(allInvItems);
                  }
                  this.isshowRefresh = true;
                  let selectedItem: any = [];
                  let cntItems = 0;
                  if (this.erpItems.length > 0) {
                      for (let i: number = 0; i < allInvItems.length; i++) {
                          if (allInvItems[i].ItemID != 0 && (allInvItems[i].ITyp == 'I' || allInvItems[i].ITyp == undefined)) {
                              selectedItem = this.erpItems.filter((o: any) => o.ItemID == allInvItems[i].ItemID);
                              if (selectedItem.length > 0) {
                                cntItems++;
                              }
                          }
                      }
                      if (cntItems > 0) {
                          this.inventoryData(reponseData)
                      } else {
                          this.getItemListData();
                      }
                  }

                  // let tempStockList = this.apiService.getCookie('erp_inv');
                  // if (tempStockList) {
                  //   this.stockList = JSON.parse(tempStockList);
                  //   if(this.stockList.length > 0){
                  //     this.stockList.push(allInvItems);
                  //   }
                  //   this.apiService.setCookie('erp_inv', JSON.stringify(this.stockList));
                  // }

                  // this.inventoryData(reponseData);
                  // let invItems: any = reponseData.Table2;
                  // if(invItems.length > 0){
                  //   for(let i: number = 0; i < invItems.length; i++){
                  //     if(invItems[i].ItemID > 0){
                  //       let storeItemList: any = invItems[i].StoreBatches;
                  //       let selectedStoreList: any = [];
                  //       if(storeItemList){
                  //         storeItemList = JSON.parse(storeItemList);
                  //         selectedStoreList = storeItemList.filter((o: any) => o.SID == this.invoiceStoreID);
                  //       }

                  //       let dispatchQty: number = 0;
                  //       let dispatchNotes: string = "";
                  //       let notes: string = "";
                  //       let selectedInvItem = allInvItems.filter((o: any) => o.ItemID == invItems[i].ItemID && o.Unit == invItems[i].SKU);
                  //       if(selectedInvItem.length > 0) {
                  //         for (let j: number = 0; j < selectedInvItem.length; j++) {
                  //           dispatchQty = Number(dispatchQty) + Number(selectedInvItem[j].Qty);             
                  //         }
                  //         // dispatchQty = selectedInvItem[0].Qty;
                  //       }
                  //       else {
                  //         selectedInvItem = allInvItems.filter((o: any) => o.ItemID == invItems[i].ItemID);
                  //         if(selectedInvItem.length > 0){
                  //           dispatchNotes = selectedInvItem[0].Qty + " " + selectedInvItem[0].Unit;
                  //         }
                  //       }                
                  //       let erpSelectedItem: Array<any> = this.erpItems.filter((o: any) => o.ItemID == invItems[i].ItemID);                  
                  //       if(erpSelectedItem.length > 0) {
                  //           if(this.copyItemListFromDoc.length > 0){
                  //             let selectedItems = this.copyItemListFromDoc.filter((o: any) => o.ItemID == erpSelectedItem[0].ItemID);
                  //             if(selectedItems.length > 0){
                  //               dispatchQty = selectedItems[0].transferQty;
                  //               notes = selectedItems[0].Notes;
                  //             } 
                  //           }
                  //           else{
                  //             notes = selectedInvItem.length > 0 ? selectedInvItem[0].Notes : ''
                  //           }

                  //           this.items.push({
                  //             Bom: false,
                  //             CategoryID: erpSelectedItem[0].CategoryID,
                  //             CategoryName: erpSelectedItem[0].CategoryName,
                  //             CurrQty: erpSelectedItem[0].CurrQty,
                  //             DU: erpSelectedItem[0].DU,
                  //             DUPrecision: erpSelectedItem[0].DUPrecision,
                  //             DefStockRate: erpSelectedItem[0].DefStockRate,
                  //             ImportanceID: erpSelectedItem[0].ImportanceID,
                  //             IsActive: erpSelectedItem[0].IsActive,
                  //             IsAvailable: erpSelectedItem[0].IsAvailable,
                  //             IsMade: erpSelectedItem[0].IsMade,
                  //             ItemCode: erpSelectedItem[0].ItemCode,
                  //             ItemID: erpSelectedItem[0].ItemID,
                  //             ItemName: erpSelectedItem[0].ItemName,
                  //             MinStockQty: erpSelectedItem[0].MinStockQty,
                  //             SKU: erpSelectedItem[0].SKU,
                  //             SKUPrecision: erpSelectedItem[0].SKUPrecision,
                  //             StoreBatches: invItems[i].StoreBatches,
                  //             StoreItemQty: selectedStoreList.length > 0 ? selectedStoreList[0].Q : 0,
                  //             StoreQty: selectedStoreList.length > 0 ? selectedStoreList[0].Q : 0,
                  //             SubCategoryID: erpSelectedItem[0].SubCategoryID,
                  //             SubCategoryName: erpSelectedItem[0].SubCategoryName,
                  //             TypeID: erpSelectedItem[0].TypeID,
                  //             ValHistAvg: erpSelectedItem[0].ValHistAvg,
                  //             ValLLP: erpSelectedItem[0].ValLPP,
                  //             DefPurchRate: selectedInvItem[0].Rate, //erpSelectedItem[0].ValStdCost,
                  //             transferQty: dispatchQty == 0 ? '' : dispatchQty,
                  //             isSelected: true,
                  //             Notes: notes, //selectedInvItem.length > 0 ? selectedInvItem[0].Notes : '',
                  //             InvQty: dispatchNotes,
                  //             isDiffUnit: selectedInvItem.length > 0 && erpSelectedItem[0].SKU != selectedInvItem[0].Unit ? true : false
                  //           })
                  //       }                 
                  //     }
                  //     this.transferQty += Number(this.items[i].transferQty);
                  //   };
                  //   this.copyItemListFromDoc = this.items;
                  // }
                  // let diffUnitItems: Array<any> = this.items.filter((o: any) => o.isDiffUnit == true);
                  // if(diffUnitItems.length > 0){
                  //   this.isInvQty = true;
                  // }
              }
          }
      }
  }

    inventoryData(reponseData: any) {
        this.transferQty = 0;
        let invoiceData = reponseData.Table1;
        let allInvItems = invoiceData[0].Items;
        if (allInvItems) {
            allInvItems = JSON.parse(allInvItems);
        }
        let invItems: any = reponseData.Table2;
        if (invItems.length > 0) {
            this.batchCnt = 0;
            for (let i: number = 0; i < invItems.length; i++) {
                if (invItems[i].ItemID > 0 && invItems[i].ItemType == 'I') {
                    let storeItemList: any = invItems[i].StoreBatches;
                    let selectedStoreList: any = [];
                    if (storeItemList) {
                        storeItemList = JSON.parse(storeItemList);
                        selectedStoreList = storeItemList.filter((o: any) => o.SID == this.invoiceStoreID);
                    }

                    let erpSelectedItem: Array<any> = this.erpItems.filter((o: any) => o.ItemID == invItems[i].ItemID);
                    if (erpSelectedItem.length > 0) {
                        // Get all items with this ItemID from allInvItems
                        let allItemsForThisID = allInvItems.filter((o: any) => o.ItemID == invItems[i].ItemID);
                        
                        // Group items by unit to handle duplicates
                        let itemsByUnit = new Map<string, any[]>();
                        allItemsForThisID.forEach((item: any) => {
                            if (!itemsByUnit.has(item.Unit)) {
                                itemsByUnit.set(item.Unit, []);
                            }
                            itemsByUnit.get(item.Unit)!.push(item);
                        });

                        // Create separate records for each unit
                        itemsByUnit.forEach((itemsInUnit: any[], unit: string) => {
                            let dispatchQty: number = 0;
                            let dispatchNotes: string = "";
                            let notes: string = "";
                            let isOriginalUnit = unit.toLocaleUpperCase() === erpSelectedItem[0].SKU.toLocaleUpperCase();

                            // Calculate total quantity for this unit
                            dispatchQty = itemsInUnit.reduce((sum, item) => sum + Number(item.Qty), 0);

                            // Set up display based on unit type
                            if (isOriginalUnit) {
                                // For original unit: show quantity in transferQty, leave InvQty empty
                                dispatchNotes = "";
                            } else {
                                // For different unit: show quantity in InvQty, leave transferQty empty
                                dispatchNotes = dispatchQty + " " + unit;
                                dispatchQty = 0; // Don't show in main quantity column
                            }

                            // Handle notes from copyItemListFromDoc or original items
                            if (this.copyItemListFromDoc.length > 0) {
                                let selectedItems = this.copyItemListFromDoc.filter((o: any) => 
                                    o.ItemID == erpSelectedItem[0].ItemID && 
                                    (isOriginalUnit ? o.isDiffUnit !== true : o.isDiffUnit === true)
                                );
                                if (selectedItems.length > 0) {
                                    if (isOriginalUnit) {
                                        dispatchQty = selectedItems[0].transferQty;
                                    }
                                    notes = selectedItems[0].Notes;
                                }
                            } else {
                                notes = itemsInUnit.length > 0 ? itemsInUnit[0].Notes || '' : '';
                            }

                            this.items.push({
                                Bom: false,
                                CategoryID: erpSelectedItem[0].CID,
                                CategoryName: erpSelectedItem[0].CN,
                                CurrQty: Number(erpSelectedItem[0].CurrQty).toFixed(erpSelectedItem[0].SKUPrecision),
                                DefStockRate: erpSelectedItem[0].DefStockRate,
                                ImportanceID: erpSelectedItem[0].Imp,
                                IsActive: erpSelectedItem[0].IsActive,
                                IsAvailable: erpSelectedItem[0].IsAvailable,
                                IsMade: erpSelectedItem[0].IsMade,
                                ItemCode: erpSelectedItem[0].ItemCode,
                                ItemID: erpSelectedItem[0].ItemID,
                                ItemName: erpSelectedItem[0].ItemName,
                                MinStockQty: erpSelectedItem[0].MinStockQty,
                                SKU: erpSelectedItem[0].SKU,
                                SKUPrecision: erpSelectedItem[0].SKUPrecision,
                                StoreBatches: invItems[i].StoreBatches,
                                StoreItemQty: selectedStoreList.length > 0 ? Number(selectedStoreList[0].Q).toFixed(erpSelectedItem[0].SKUPrecision) : 0,
                                StoreQty: selectedStoreList.length > 0 ? selectedStoreList[0].Q : 0,
                                SubCategoryID: erpSelectedItem[0].SCID,
                                SubCategoryName: erpSelectedItem[0].SC,
                                TypeID: erpSelectedItem[0].TypeID,
                                ValHistAvg: erpSelectedItem[0].ValHistAvg,
                                ValLLP: erpSelectedItem[0].ValLPP,
                                DefPurchRate: itemsInUnit.length > 0 ? itemsInUnit[0].Rate : erpSelectedItem[0].ValStdCost,
                                transferQty: dispatchQty == 0 ? '' : dispatchQty,
                                isSelected: true,
                                Notes: notes,
                                InvQty: dispatchNotes,
                                isDiffUnit: !isOriginalUnit,
                                BatchType: invItems[i].BatchType ? invItems[i].BatchType : 0,
                                Batches: [],
                                hasBatches: (invItems[i].BatchType == 1 || invItems[i].BatchType == 2) ? true : false
                            });

                            this.batchCnt = this.batchCnt + 1;
                            this.transferQty += isOriginalUnit && dispatchQty ? Number(dispatchQty) : 0;
                        });
                    }
                }
            };
            this.copyItemListFromDoc = this.items;
        }
        let diffUnitItems: Array<any> = this.items.filter((o: any) => o.isDiffUnit == true);
        if (diffUnitItems.length > 0) {
            this.isInvQty = true;
        }
    }

  // Dilivery Challan Print data
  printTranjection(id: number) {
      let XnID = this.commonService.encryptData(id);
      let AgencyID = this.commonService.encryptData(this.jarvisData[0].AgencyIDs);
      let target: string = "_blank";
      // if(this.isWeb == false){
      //   target = "_self";
      // }
      window.open('transactionHistory?XnID=' + XnID + "&aid=" + AgencyID, target, 'Height= 800px, Width= 1000px, padding:10px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
  }

  getItemListData() {
      var jarvis = this.apiService.getCookie("Jarvis");
      if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
      }

      let data = [{
          StatusID: 1,
          StoreID: 0
      }];

      let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          ForERPAgencyID: this.MTbl[0].ERPAgencyID,
          myLastSyncDT: null,
          isWeb: true,
          actionType: 'get',
          moduleID: 5,
          data: JSON.stringify(data)
      }];
      this.SpinnerService.show();
      this.apiService.getData(myParams, this.successRespItem.bind(this), this.failureRespItem.bind(this));
  }

  //successResp - success  get handler
  successRespItem(res: any) {
      this.SpinnerService.hide();
      if (res.error) {
          console.log(res.message);
      } else {
          if (res) {

              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData) {
                  let data = reponseData;
                  let tempItems = data.Table1;
                  this.Items = tempItems.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));

                  for (let x = 0; x < this.Items.length; x++) {
                      if (this.Items[x].StoreBatches) {
                          let tempData = JSON.parse(this.Items[x].StoreBatches)
                          let tempQTY = tempData.filter((x: any) => x.SID == 0)
                          if (tempQTY.length > 0) {
                              this.Items[x].CurrQty = Number(tempQTY[0].Q).toFixed(this.Items[x].SKUPrecision)
                          } else {
                              this.Items[x].CurrQty = 0
                          }
                      } else {
                          this.Items[x].CurrQty = Number(this.Items[x].CurrQty).toFixed(this.Items[x].SKUPrecision)
                      }
                      this.Items[x].TotalValue = Number(this.Items[x].CurrQty) * Number(this.Items[x].DefStockRate)
                      if (this.Items[x].CID > 0) {
                          for (let i = 0; i < this.categories.length; i++) {
                              if (this.Items[x].CID == this.categories[i].cid) {
                                  if (this.categories[i].cnm) {
                                      this.Items[x].CN = this.categories[i].cnm;
                                  } else {
                                      this.Items[x].CN = '';
                                  }
                                  let subCategory = this.categories.filter((A: any) => A.cid == this.Items[x].CID)
                                  let tempSubCat = subCategory[0].sub.filter((s: any) => s.sid == this.Items[x].SCID)
                                  if (tempSubCat.length > 0) {
                                      this.Items[x].SC = tempSubCat[0].snm
                                  } else {
                                      this.Items[x].SC = ''
                                  }
                              }
                          }
                      } else {
                          this.Items[x].CN = ''
                      }
                      this.Items[x].SCN = (this.Items[x].CN == '' ? '-' : this.Items[x].CN) + (this.Items[x].SC ? ' / ' : '') + (this.Items[x].SC ? this.Items[x].SC : '');
                  }
                  this.apiService.setIDB('erp_inv', this.Items);
                  this.Items = this.Items.filter((a: any) => a.IsActive ? a.IsActive : 0);
                  this.erpItems = this.Items;
              }
          }
      }
  }

  //failureResp - failure handler
  failureRespItem(res: any) {
      this.SpinnerService.hide();
      if (res.error) {
          console.log(res.message);
      } else {
          this.apiService.successAlert(res.message);
      }
  }

  //open multiunit
  openMultiUnitCal(obj: any, ind: number) {
      console.log("Selected Obj", obj);
      let invQtyUnit = obj.InvQty.split(" ");
      let calData = {
          itemUnit: obj.SKU,
          invQty: invQtyUnit[0],
          invoiceUnit: invQtyUnit[1],
          skuPrecision: obj.SKUPrecision
      };

      this.modalReference = this.modalService.open(MultiUnitCalculatorComponent, {
          windowClass: "calculator",
          backdrop: 'static',
          keyboard: false
      });
      this.modalReference.componentInstance.mdlRef = this.modalReference;
      this.modalReference.componentInstance.itemUnit = calData.itemUnit;
      this.modalReference.componentInstance.invQty = calData.invQty;
      this.modalReference.componentInstance.invoiceUnit = calData.invoiceUnit;
      this.modalReference.componentInstance.ind = ind;
      this.modalReference.componentInstance.skuPrecision = calData.skuPrecision
      this.modalReference.result.then((result: any) => {
          if (result.length > 0) {
              this.items[ind].transferQty = result[0].calQty;
          }
      });
  };

  //getRelDetails() - Get relative data
  getRelDetails(relID: any) {

      let data = [{
          relativeid: relID
      }]

      let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: this.apiService.getCookie("MyLastSyncDT"),
          isWeb: true,
          ForERPAgencyID: this.MTbl[0].ERPAgencyID,
          actionType: 'getRelDetails',
          moduleID: 902,
          data: JSON.stringify(data)
      }];

      return this.apiService.getData(myParams, this.successRelData.bind(this), this.failureRelData.bind(this));

  }

    //successResp - success  get handler
    successRelData(res: any) {
        this.SpinnerService.hide();
        if (res.error) {
            console.log(res.message);
        } else {
            if (res) {
                var reponseData = JSON.parse(res.updatePackage);
                if (reponseData) {
                    this.custAddress = reponseData.Table1[0].Adrs;
                    if (this.custAddress) {
                        this.custAddress = JSON.parse(this.custAddress);
                        // Filter out invalid addresses
                        this.custAddress = $.grep(this.custAddress, function(o: any) {return o.AddrID != 0 });
                        this.isShowAddr = true;

                        if (this.custAddress.length > 0) {
                            if (this.id == 7 || this.id == 8) {
                                // Select the first address by default
                                this.selCustAddr = this.custAddress[0].AddrID;
                                this.createCustAddr();
                            }
                        }

                        if (this.selCustAddr > 0) {
                            this.createCustAddr();
                        }
                    }
                }
            }
        }
    }

  //failureResp - failure handler
  failureRelData(res: any) {
      this.SpinnerService.hide();
      if (res.error) {
          console.log(res.message);
      } else {
          this.apiService.successAlert(res.message);
      }
  }

  RefreshPage() {
      window.location.reload();
  }
  resetBatchesData() {
      this.batchList = [];
      this.appService.updateBathesData(this.batchList);
  }

  openCompModal(id: any) { 

    if (!this.isFromInvList) {
        id = this.type == 'DCRN' ? 2 : (this.type == 'DDBN' ? 1 : id);
    } else {
        if (!this.isInternalXfer) {
            return;
        }
    }

    let tmpCust = this.HTbl.filter((a: any) => a.C == true);
    let tmpSup = this.HTbl.filter((a: any) => a.S == true);

    if ((id == 1) && (tmpSup.length == 0)) {
        this.apiService.successAlert('Please configure the supplier from Network > Connections.');
        return;
    }

    if ((id == 2) && (tmpCust.length == 0)) {
        this.apiService.successAlert('Please configure the customer from Network > Connections.');
        return;
    }
    this.modalReference = this.modalService.open(FindCompComponent, {
        windowClass: "findCmp width100",
        backdrop: 'static',
        keyboard: false
    });
    this.modalReference.componentInstance.isCust = id == 1 ? false : true;
    this.modalReference.componentInstance.isShowCS = (this.id == 1 || this.id == 5) ? true : false;
    this.modalReference.componentInstance.custID = this.customer.id;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.result.then((result: any) => {
        if (result.length > 0) {
            this.customer.id = result[0].RI;
            this.customer.name = String(result[0].Cmp).trim() == "-"  ? result[0].Name : result[0].Cmp;
            this.isCustSelected = true;
            // this.selectedCustomerAddress = JSON.stringify({
            //     City: result[0].City,
            //     State: result[0].State
            // });
            let tmpCustAddr = this.HTbl.filter((a: any) => a.RI == this.customer.id);
            this.getRelDetails(tmpCustAddr[0].RI);
        }
    });
  }
}